import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

  export const createInspection = async (data) => {
      try {
        const response = await api.create(`/inspections/add`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getInspection = async () => {
      try {
        const response = await api.get(`/inspections/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  
  export const getInspectionByCategory = async () => {
    try {
      const response = await api.get(`/inspections/category/Incident`);
      return response;
    } catch (error) {
      throw error;
    }
};

  export const updateInspection = async ( id, data) => {
      try {
        const response = await axios.patch(`/inspections/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getInspectionById = async (id) => {
    try {
      const response = await api.get(`/inspections/${id}`);
        return response;
      } catch (error) {
        throw error;
    }
  };

  export const InspResponse = async (id, data) => {
    try {
      const response = await api.get(`/inspections/response/${id}`, data);
        return response;
      } catch (error) {
        throw error;
    }
  };

  export const getInspectionByVehId = async (vehId) => {
    try {
      const response = await api.get(`/history/vehicles/${vehId}`);
        return response;
      } catch (error) {
        throw error;
    }
  };
  export const getInspectionByUserId = async (UserId) => {
    try {
      const response = await api.get(`/inspections/user/${UserId}`);
      return response;
    } catch (error) {
      throw error;
    }
};

